import React, { useState } from 'react';
import Input from '../../../../../../../../shared/design-system/components/input';
import { IProps } from './types';
import { isEnterKey } from '../../../../../../../../shared/utils/event';
import { InputIconConfig } from '../../../../../../../../shared/design-system/components/input/types';

const PhoneNumberListSearch: React.FC<IProps> = ({ search, onChange }) => {
  const [searchValue, setSearchValue] = useState(search);
  const [showIconOnSearch, setShowIconOnSearch] = useState<InputIconConfig[]>([
    {
      place: Input.IconPlace.Left,
      identifier: 'search',
    },
  ]);

  const clearSearch = () => {
    setSearchValue('');
    onChange('');
    setShowIconOnSearch([
      {
        place: Input.IconPlace.Left,
        identifier: 'search',
      },
    ]);
  };

  const onSearchKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget || { value: '' };

    if (isEnterKey(event.key) && value !== search) {
      onChange(value);
    }
  };

  const onSearchChangeHandler = (value: string) => {
    if (value.length > 0) {
      setShowIconOnSearch([
        {
          place: Input.IconPlace.Left,
          identifier: 'search',
        },
        value.length > 0 && {
          place: Input.IconPlace.Right,
          identifier: 'close-o',
          onClick: clearSearch,
        },
      ]);
    } else {
      setShowIconOnSearch([
        {
          place: Input.IconPlace.Left,
          identifier: 'search',
        },
      ]);
    }
    setSearchValue(value);
  };

  return (
    <Input
      defaultValue={search}
      value={searchValue}
      key={search}
      onKeyPress={onSearchKeyPress}
      onChange={onSearchChangeHandler}
      placeholder="Search here..."
      icons={showIconOnSearch}
    />
  );
};

export default PhoneNumberListSearch;

